import React, { useEffect, useState } from "react";
import PageTitle from "../components/pagetitle/PageTitle";

import iconCoins from "../assets/images/icon/icon-bonus.webp";

import { Link, useLocation } from "react-router-dom";
import Footer from "../components/footer";
import { Table, Pagination } from "antd";
import { fatchOffers, getAllTypeOffers } from "../services/offers/offersApi";
import { toast, ToastContainer } from "react-toastify";
import { formateCoins, promotion } from "../function";
import ComfortTradeModal from "../components/ComfortTradeModal";
import Faqs2 from "../components/faqs/Faqs2";
import dataFaqs from "../assets/fake-data/data-faq";
import { useTranslation } from "react-i18next";
import NewCollection from "../components/new_offers/Collection";
import Card_sale from "../components/new_offers/Card_sale";

function Collection(props) {
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const [offers, setOffers] = useState([]);
  const [search, setSearch] = useState("");
  const [typeOffers, setTypeOffers] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const location = useLocation();
  const [typeId, setTypeId] = useState(null);
  const [isOpenComfortTrade, setIsOpenComfortTrade] = useState(false);
  const { t } = useTranslation();
  const [selectedOffer,setSelectedOffer]=useState({});
  const [discount,setDiscount]=useState(0);

  const getOffers = async () => {
    await fatchOffers(search, limit, page, typeId)
      .then((response) => {
        setOffers(response.data.offres);
        setTotalRows(response.data.totalRows);
      })
      .catch((error) => {
        toast.error("api error");
      });
  };
  const fetchTypeOffers = async () => {
    try {
      const response = await getAllTypeOffers();
      setTypeOffers(response.data); // Assuming response.data contains the array of type offers
    } catch (error) {
      toast.error("Failed to fetch type offers"); // Notify error
    }
  };

  useEffect(() => {
    getOffers();
    fetchTypeOffers();
    localStorage.removeItem("couponCode");
  }, [search, page, typeId]);

  const handlePageClick = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="page-collection">
      <PageTitle title={t("Collection")} />

      <section className="tf-collection-inner">
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
             


              <div className="row">
                <div className="col-lg-8">
                  <NewCollection selectedOffer={selectedOffer} setSelectedOffer={setSelectedOffer} />
                </div>
                <div className="col-lg-4">
                  <Card_sale selectedOffer={selectedOffer} setDiscount={setDiscount} discount={discount} />
                </div>

              </div>

              <div className="row">
                  <Faqs2 />
              </div>
              

            

              {/* <div className="container">
                  {offers.map((offer) => (
                    <div className="my-package" key={offer.key}>
                      {offer.promotion !== null && offer.promotion > 0 && (
                        <div className="my-badge">{`${offer.promotion} %`}</div>
                      )}

                      <div className="d-flex justify-content-start mt-4 my-3">
                        <h4>
                          <img src={iconCoins} width={30} className="mr-2" />{" "}
                          {t("Coins")} {formateCoins(offer.coins)}
                        </h4>
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        <h6>
                          {typeOffers.find((t) => t.id === offer.type_id)
                            ?.nom ?? ""}
                        </h6>
                      </div>
                      <div className="d-flex justify-content-end mt-2">
                        <p>
                          {`${promotion(offer.montant, offer.promotion)} USD`}
                          {offer.promotion !== null && offer.promotion > 0 && (
                            <span
                              style={{
                                textDecoration: "line-through",
                                textAlign: "center",
                              }}
                              className="strike-text ml-3"
                            >
                              {offer.montant} USD
                            </span>
                          )}
                        </p>
                      </div>
                      <div className="d-flex justify-content-end mt-4">
                        <Link
                          style={{
                            fontFamily: "Bakbak One",
                            fontSize: "16px",
                            lineHeight: "24px",
                            backgroundColor: "#21E786",
                            color: "#040B11",
                            padding: "17px 50px",
                            display: "inline-block",
                            textAlign: "center",
                            WebkitAppearance: "none",
                            transition: "all 0.3s ease",
                          }}
                          className="py-3"
                          to={`/item-details/${offer.id}`}
                        >
                          {t("BUY")}
                        </Link>
                      </div>
                    </div>
                  ))}
                  <Pagination
                    current={page}
                    pageSize={limit}
                    total={totalRows}
                    onChange={handlePageClick}
                    style={{ marginTop: "20px", textAlign: "center" }}
                  />
                </div> */}
              
            </div>
          </div>
        </div>
      </section>
     

      <Footer />
      <ToastContainer draggable />
      <ComfortTradeModal
        isOpen={isOpenComfortTrade}
        setIsOpen={() => setIsOpenComfortTrade(false)}
      />
    </div>
  );
}

export default Collection;
